import React from "react";
import PropTypes from "prop-types";
import { MapPin, Map, Navigation } from "react-feather";

const ViewInquiryModal = ({ show, onClose, inquiry }) => {
  if (!show || !inquiry) return null;

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="mdi mdi-eye me-2 text-primary"></i>
              Inquiry Details
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              {/* Left Side - Inquiry Details */}
              <div className={inquiry.rcCardImage ? "col-md-8" : "col-12"}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Full Name:
                      </label>
                      <p className="form-control-plaintext">
                        {inquiry.fullName || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Phone Number:
                      </label>
                      <p className="form-control-plaintext">
                        {inquiry.phoneNumber || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Email:</label>
                      <p className="form-control-plaintext">
                        {inquiry.email || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Enquiry Type:
                      </label>
                      <p className="form-control-plaintext">
                        {inquiry.enquiryType || "N/A"}
                      </p>
                    </div>
                  </div>
                  {inquiry.leadType && (
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Lead Type:
                        </label>
                        <p className="form-control-plaintext text-capitalize">
                          {inquiry.leadType}
                        </p>
                      </div>
                    </div>
                  )}
                  {inquiry.vehicleNumber && (
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Vehicle Number:
                        </label>
                        <p className="form-control-plaintext">
                          {inquiry.vehicleNumber}
                        </p>
                      </div>
                    </div>
                  )}
                  {inquiry.quotationPdf && (
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label fw-semibold d-block">
                          Quotation PDF:
                        </label>
                        <a
                          href={inquiry.quotationPdf}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary"
                        >
                          <i className="mdi mdi-file-pdf-box me-2"></i>
                          View Quotation
                        </a>
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Submitted On:
                      </label>
                      <p className="form-control-plaintext">
                        {formatDate(inquiry.createdAt)}
                      </p>
                    </div>
                  </div>
                  {inquiry.message && (
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Message:
                        </label>
                        <p className="form-control-plaintext">
                          {inquiry.message}
                        </p>
                      </div>
                    </div>
                  )}
                  {inquiry.location && (
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label fw-semibold d-flex align-items-center">
                          <MapPin size={18} className="me-2" />
                          Location Details
                        </label>
                        <div className="border rounded p-3 bg-light">
                          {inquiry.location.address && (
                            <p className="mb-2">
                              <strong>Address:</strong>{" "}
                              {inquiry.location.address}
                            </p>
                          )}
                          <div className="row">
                            {inquiry.location.city && (
                              <div className="col-md-4">
                                <p className="mb-1">
                                  <strong>City:</strong> {inquiry.location.city}
                                </p>
                              </div>
                            )}
                            {inquiry.location.state && (
                              <div className="col-md-4">
                                <p className="mb-1">
                                  <strong>State:</strong>{" "}
                                  {inquiry.location.state}
                                </p>
                              </div>
                            )}
                            {inquiry.location.pincode && (
                              <div className="col-md-4">
                                <p className="mb-1">
                                  <strong>Pincode:</strong>{" "}
                                  {inquiry.location.pincode}
                                </p>
                              </div>
                            )}
                          </div>
                          {inquiry.location.coordinates && (
                            <div className="mt-2">
                              <a
                                href={`https://www.google.com/maps?q=${inquiry.location.coordinates[1]},${inquiry.location.coordinates[0]}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary mt-2"
                              >
                                <Map size={14} className="me-1" />
                                View on Map
                              </a>
                              <a
                                href={`https://www.google.com/maps/dir/?api=1&destination=${inquiry.location.coordinates[1]},${inquiry.location.coordinates[0]}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-success mt-2 ms-2"
                              >
                                <Navigation size={14} className="me-1" />
                                Get Directions
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Right Side - RC Card Image (if available) */}
              {inquiry.rcCardImage && (
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      RC Card Image:
                    </label>
                    <div className="text-center">
                      <img
                        src={inquiry.rcCardImage}
                        alt="RC Card"
                        className="img-fluid rounded border"
                        style={{
                          maxHeight: "250px",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                  <div className="card mt-3">
                    <div className="card-body">
                      <h6 className="card-title d-flex align-items-center">
                        <i className="mdi mdi-information-outline me-2"></i>
                        Inquiry Details
                      </h6>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Submitted On:</span>
                        <span>{formatDate(inquiry.createdAt)}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Last Updated:</span>
                        <span>{formatDate(inquiry.updatedAt)}</span>
                      </div>
                      {inquiry.leadType && (
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Lead Type:</span>
                          <span className="text-capitalize">
                            {inquiry.leadType}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ViewInquiryModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  inquiry: PropTypes.shape({
    _id: PropTypes.string,
    fullName: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    enquiryType: PropTypes.string,
    vehicleNumber: PropTypes.string,
    rcCardImage: PropTypes.string,
    message: PropTypes.string,
    leadType: PropTypes.string,
    location: PropTypes.shape({
      type: PropTypes.string,
      coordinates: PropTypes.arrayOf(PropTypes.number),
      city: PropTypes.string,
      state: PropTypes.string,
      pincode: PropTypes.string,
      address: PropTypes.string,
    }),
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    __v: PropTypes.number,
  }),
};

export default ViewInquiryModal;
